import { render, staticRenderFns } from "./RpmFuelSpeed.vue?vue&type=template&id=22052280&scoped=true"
import script from "./RpmFuelSpeed.vue?vue&type=script&lang=js"
export * from "./RpmFuelSpeed.vue?vue&type=script&lang=js"
import style0 from "./RpmFuelSpeed.vue?vue&type=style&index=0&id=22052280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22052280",
  null
  
)

export default component.exports